import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "antd";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import Category from "../DesignSystem/Category/Category";
import CategorySection from "../DesignSystem/CategorySection/CategorySection";
import { getCategoriesSelector } from "../../Categories/Infrastructure/Categories.reducer";
import { getCategories } from "../../Categories/Application/Categories.business";
import './Categories.css';

const Categories = ({ stream }) => {
  const records = useSelector(getCategoriesSelector);
  const [active, setActive] = useState("");
  const swiperRef = useRef(null);
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);

  useEffect(() => {
    if (records.length > 0) {
      setActive(records[0].name);
    }
  }, [records]);

  useEffect(() => {
    async function fetchData() {
      await getCategories({
        filter: { scope: "scope 3", [stream]: true },
      });
    }
    fetchData();
  }, [stream]);

  const onChange = ({ target: { value } }) => {
    setActive(value);
  };

  return (
    <div className="categories-wrapper">
      <Row gutter={5}>
        <Col span={24}>
          <div className="categories-swiper-container">
            <div ref={navigationPrevRef} className="categories-prev"></div>
            <div ref={navigationNextRef} className="categories-next"></div>

            <Swiper
              ref={swiperRef}
              modules={[Navigation]}
              navigation={{
                prevEl: navigationPrevRef.current,
                nextEl: navigationNextRef.current,
              }}
              onInit={(swiper) => {
                swiper.params.navigation.prevEl = navigationPrevRef.current;
                swiper.params.navigation.nextEl = navigationNextRef.current;
                swiper.navigation.init();
                swiper.navigation.update();
              }}
              slidesPerView="auto"
              spaceBetween={8}
              loop={false}
              allowTouchMove={true}
              speed={400}
              className="categories-swiper"
              updateOnWindowResize
            >
              {records.map(({ name, id }) => (
                <SwiperSlide key={id} style={{ width: 'auto' }}>
                  <Category
                    id={id}
                    title={name}
                    isActive={active === name}
                    onChange={onChange}
                    activeValue={active}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </Col>
      </Row>

      {records.map(({ id, name }) =>
        active === name ? (
          <CategorySection key={id} id={id} title={name} />
        ) : null
      )}
    </div>
  );
};

export default Categories;